import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_INVOICE_LOADING = 'DELETE_INVOICE_LOADING';
export const DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_RESET = 'DELETE_INVOICE_RESET';
export const DELETE_INVOICE_REJECT = 'DELETE_INVOICE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteInvoiceLoading = () => ({ type: DELETE_INVOICE_LOADING });
export const deleteInvoiceSuccess = (payload) => ({ type: DELETE_INVOICE_SUCCESS, payload });
export const deleteInvoiceReset = () => ({ type: DELETE_INVOICE_RESET });
export const deleteInvoiceReject = (payload) => ({ type: DELETE_INVOICE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteInvoiceRequest = async (getState, id) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/ClientesBillingTracking/web/DeleteClientesBillingTracking?billingTranckingId=${id}`, options);
};